<template>
    <div v-click-outside="closeResultsDropdown" class="relative normal-case h-full mb-4 lg:mb-0 lg:mr-6 lg:ml-8">
        <div class="h-full relative">
            <input
                v-model="query"
                type="text"
                class="outline-none py-6 lg:py-0 w-full lg:w-70 xl:w-80 h-full px-4 lg:pl-10 focus:outline-none bg-gray-100 lg:border-l lg:border-r lg:border-gray-300"
                placeholder="Search..."
                @keyup.enter="openResultsDropdown"
            />
            <span class="hidden lg:inline absolute left-0 ml-4" style="top: 29px;">
                <i class="fa fa-search"></i>
            </span>
        </div>
        <div v-if="showResultsDropdown" class="results absolute">
            <div v-if="!loading && results" class="founds-list">
                <div v-if="results.freelancers.length > 0" class="bg-gray-200 font-semibold text-base px-4 py-2">
                    Talents
                </div>
                <a
                    v-for="freelancer in results.freelancers"
                    :key="freelancer.id"
                    :href="`/profiles/${freelancer.username}`"
                    class="flex items-center text-gray-900 hover:text-gray-900 hover:bg-gray-200 px-4 py-2 border-b border-gray-300"
                >
                    <div class="avatar w-12 h-12 mr-2 border-gray-500 border rounded-full">
                        <user-avatar :avatar-url="freelancer.avatar_url" :username="freelancer.name"></user-avatar>
                    </div>
                    <span class="name flex flex-col items-start leading-none">
                        <div class="normal-case font-bold text-base mb-1">{{ freelancer.name }}</div>
                        <div class="text-gray-500 normal-case">{{ freelancer.profile.title }}</div>
                    </span>
                </a>
                <div v-if="results.projects.length > 0" class="bg-gray-200 font-semibold text-base px-4 py-2">
                    Jobs
                </div>
                <a
                    v-for="project in results.projects"
                    :key="project.id"
                    :href="`/projects/${project.slug}`"
                    class="block text-gray-900 hover:text-gray-900 hover:bg-gray-200 px-4 py-3 border-b border-gray-300"
                >
                    <div class="normal-case font-bold text-base">{{ project.title }}</div>
                    <div class="flex space-x-8 mt-2">
                        <span v-if="project.budget" class="flex items-center">
                            <svg-icon icon="currency-dollar" class="w-5 mr-1"></svg-icon>
                            <span class="text-gray-600 font-bold">{{ project.budget | formattedCurrency }}</span>
                        </span>
                        <span v-if="project.country" class="flex items-center mr-8">
                            <svg-icon icon="location-pin" class="w-5 mr-1"></svg-icon>
                            <span class="text-gray-600">{{ project.country }}</span>
                        </span>
                    </div>
                </a>
            </div>
            <div v-if="loading" class="not-results flex items-center justify-around h-20 w-full">
                <i class="text-gray-600 fa fa-spinner fa-pulse fa-2x fa-fw"></i>
            </div>
            <div v-if="!loading && !results" class="not-results flex items-center justify-around h-20 w-full">
                Sorry, no results found.
            </div>
            <div v-if="!loading" class="flex items-center justify-around py-4">
                <a href="/profiles">Advance Search</a>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    data() {
        return {
            loading: false,
            query: null,
            results: null,
            showResultsDropdown: false,
            typingTimeout: null
        };
    },

    watch: {
        query: function(query) {
            clearTimeout(this.typingTimeout);

            if (query.length === 0) {
                this.closeResultsDropdown();
                return;
            }

            this.typingTimeout = setTimeout(() => {
                this.initSearch();
            }, 1000);
        }
    },

    methods: {
        openResultsDropdown() {
            this.showResultsDropdown = true;
        },

        closeResultsDropdown() {
            this.results = null;
            this.showResultsDropdown = false;
        },

        initSearch() {
            this.openResultsDropdown();
            this.loading = true;
            axios
                .get(`/api/search?q=${this.query}`)
                .then(response => {
                    this.results = response.data;
                })
                .then(() => (this.loading = false));
        }
    }
};
</script>

<style lang="scss" scoped>
.results {
    width: 100%;
    max-height: 400px;
    overflow-y: scroll;
    overflow-x: hidden;
    @apply bg-white mt-1 rounded border border-gray-400 shadow-lg text-gray-900;
}
</style>
